/* eslint-disable */
import store from '@/store/store'
import { loadData, convertDataArrayToObject } from "./utilities";
import { EventBus } from '@/eventBus';
import _ from 'lodash';
import * as d3 from "d3";

class CrainD3Vis {

    controlNormalFormatting(selection) {
        // Opposite of select coloring. Needs to be defined in inheriting class
    }

    controlSelectFormatting(selection) {
        // Opposite of normal coloring. Needs to be defined in inheriting class
    }

    controlDataPointFormatting(selection) {
        if (this.selectModus) {
            this.controlSelectFormatting(selection)
        } else {
            this.controlNormalFormatting(selection)
        }
    }

    controlSelect() {
        if (this.selectModus) { this.activateSelect() } else { this.deActivateSelect() }
    }

    activateSelect() {
        //let filtToApply = [];
        this.selectModus = true;
        this.svg.selectAll('.' + this.selectClass)
            .on('click', (d, event) => {
                // Check if there is a data element for a clicked svg element (is necessary for worldMap, that can have
                // visualized elements (countries) that have no data, but nevertheless are visualized
                //console.log(d, this.selectClass, "Selection started");
                this.crainData.toggleSelect(d);
                //filtToApply = this.crainData.selectedQuery(this.svgDiv);
                this.svg.selectAll('.' + this.selectClass).call(this.controlDataPointFormatting)
                this.crainData.selectedQuery(this.svgDiv);
            })
            .call(this.controlDataPointFormatting)
        /*
        if(filtToApply.length){
            console.log("Calling update visuals", this.svgDiv, filtToApply);
            store.dispatch('saveActiveVisual', [this.svgDiv, filtToApply]);
            store.dispatch('saveSubsetFilter', [this.svgDiv, filtToApply]);
        }
        */
    }
    
    deActivateSelect(reset = false) {
        this.selectModus = false;
        this.svg.selectAll('.' + this.selectClass)
            .on('click', function(d, event) {
                console.log(d);
                let filt = [];
                let currSubset = [];
                d.fingerprint.filter(f => f).forEach((r) => {
                    filt.push({ "_id": r });
                    filt.push("AND")
                });
                filt = filt.slice(0, -1);
                if (filt.length === 1) {
                    filt = filt[0]
                }
                if (store.state.filter.filterFocused !== null) {
                    currSubset = store.state.filter.subsetFilter;
                    currSubset[0] = filt;
                }
                //store.dispatch('saveActiveVisual', [this.svgDiv, currSubset]);
                //store.dispatch('saveSubsetFilter', [this.svgDiv, currSubset]);
                return currSubset;
            })
            .call(this.controlDataPointFormatting);
        if (reset) { this.resetSelect() }
    }

    resetSelect() {
        /**
         * Reset selected elements of CrainData object
         */
        this.crainData.resetSelect();
    }

    constructor(svg, cd, svgDiv, limit = false) {
        /**
         * svg: svg where Visualization will be added
         * cd: object of type crainData
         * **/
        this.svg = svg;
        this.svgDiv = svgDiv;
        this.responsive = true;
        this.crainData = cd;
        this.selectModus = true;
        this.data = undefined;
        this.selectClass = '';
        this.controlDataPointFormatting = this.controlDataPointFormatting.bind(this);
        this.dataLimit = limit;
    }

    destroy() {
        if (this.svg) {
            this.svg.remove();
            console.log("source destroyed");
        }
    }
}

class CrainData {

    async load(limit = false) {
        this.rawData = await loadData(this.request);
        // Add a method to limit data here
        if(this.rawData){
            if(limit){
                //await this.limitizedataSize();
            }
            this.convertRawDataToObject();
            this.calculateRanges();
            this.prep();
            return this
        }
    }

    /** Why not truncate data to have only 100 values at maximum. Its just a try */
    async limitizedataSize(){
        let newLayers = [];
        const topSize = this.rawData.sorts.X.size.length > 50?
            this.rawData.sorts.X.size.slice(-50):
            this.rawData.sorts.X.size;
        const topRecency = this.rawData.sorts.X.recency.length > 50?
            this.rawData.sorts.X.recency.slice(-50):
            this.rawData.sorts.X.recency;
        let itr = 0;
        Object.values(this.rawData.data).forEach(dataStore => {
            Object.keys(dataStore).forEach(key => {
                const index = parseInt(key.split("_")[0]);
                if(!topSize.includes(index) && !topRecency.includes(index)){
                    newLayers.push(null);
                    delete this.rawData.data['0'][key];
                }
                else{
                    newLayers.push(this.rawData.layers[0][index]);
                }
            })
        })
        this.rawData.layers[0] = newLayers;
    }
    /**
     * Some data is received as array. Convert to object, with proper configuration
     **/
    convertRawDataToObject() {
        
        Object.values(this.rawData.data).forEach(dataStore => {
            //console.log(dataStore);    
            //dataStore = this.limitizedataSize(dataStore, 100);
            Object.values(dataStore).forEach(el => {
                el.data = convertDataArrayToObject(el.data, "data");
                if (el.filtdata) {
                    el.filtdata = convertDataArrayToObject(el.filtdata, "filtdata");
                }
            })
        })
    }

    /**
     * Calculates the ranges of (some) available metrics
     **/
    calculateRanges() {
        let arrSize = [];
        let arrRecency = [];
        Object.values(this.rawData.data).forEach(arr => {
            arrSize = arrSize.concat(Object.values(arr).map(x => x.data ? x.data.size : 0));
            arrRecency = arrRecency.concat(Object.values(arr).map(x => x.data ? x.data.recency : 0));
        });

        this.sizeRange = [1, d3.max(arrSize)];
        // let recMin = d3.min(arrRecency);
        // let recMax = d3.max(arrRecency);
        // Limit range
        // this.recencyRange = [d3.max([-3, recMin]), d3.min([3, recMax])]
        this.recencyRange = [-3, 3];
    }

    resetSelect() {
        this.selected = new Set();
    }

    toggleSelect(d) {
        //console.log(d);

        if (d.data) {
            if (this.selected.has(d)) {

                this.selected.delete(d);
                d.selected = false;
                if (this.selected.size === 0) {
                    this.processedData.forEach(el => el.isSelect = false)
                }
            } else {
                this.selected.add(d);
                d.selected = true;
                if (this.selected.size === 1) {
                    this.processedData.forEach(el => el.isSelect = true)
                }
            }
        }

        let activations = [];
        // Filter removes undefined
        let layers = _.flatten(this.xLayers.concat(this.yLayers).concat(this.zLayersBase)).filter(x => (x));
        this.selected.forEach(item => {
            // Its a fingerprint consisting out of ["aa_13", "Fields_15", null]
            let act = item.fingerprint.filter(x => (x)).map(fp => _.find(layers, sel => { return sel._id === fp }));
            activations.push(act)
        });
        //EventBus.$emit('showOptions', activations);
    }

    selectedQuery(svgDiv) {
        //console.log("Second function");
        let fullFilt = [];
        let subsetFilt = [];
        this.selected.forEach(d => {
            let filt = [];
            //console.log(d);
            const layers = d.fingerprint.filter(f => f).slice(0, -1);
            layers.forEach((r) => {
                filt.push({ "_id": r });
                filt.push("AND")
            });
            filt = filt.slice(0, -1);
            if (filt.length === 1) {
                filt = filt[0]
            }
            fullFilt.push(filt);
            fullFilt.push("OR");
        });
        fullFilt = fullFilt.slice(0, -1);
        if (fullFilt.length > 0) {
            subsetFilt.push(fullFilt)
        } else {
            subsetFilt = [];
            //svgDiv = null;
        }
        
        if (store.state.filter.filterFocused !== null) {
            if (fullFilt.length > 0) {
                subsetFilt.push('AND');
            }
            subsetFilt.push(store.state.filter.filterFocused.rawquery);
        }
        
        store.dispatch('saveActiveVisual', [svgDiv, subsetFilt]);
        store.dispatch('saveSubsetFilter', [svgDiv, subsetFilt]);
        //console.log(JSON.stringify(subsetFilt));
        //return subsetFilt
    }


    /**
     * Prepare the data (make it "active") for a certain Z-axis, filter and sortings
     *
     * z = (default: 0) number on z-axis that needs to be processed or visualized
     * filtNum = (default: 0) which filterdata that needs to be used (if it exists)
     * sort_X = (default: normal) sorting that needs to be applied on X-axis
     * sort_Y = (default: normal) sorting that needs to be applied on Y-axis
     * sizeLimit = [0, 9999] min and max size limits in array
     * recencyLimit = [-3, 3] min and max recency limits in array
     **/
    prep(z = 0, filtNum = 0, sort_X = "normal", sort_Y = "normal", sizeLimit = undefined,
        recencyLimit = undefined) {

        let xSorter, ySorter;
        let xLayers = this.rawData.layers[0];
        let yLayers = this.rawData.layers[1];
        let zLayersBase = this.rawData.layers[2];
        let subsetLayers = this.rawData.layers[4];

        Array(sort_X, sort_Y).forEach(function(sortAxis, c) {
            let rev = false;
            if (c === 0) {
                if (sort_X.endsWith("_des")) {
                    rev = true;
                    sort_X = sort_X.replace('_des', '')
                }
                xSorter = sort_X !== "normal" ? [...this.rawData.sorts.X[sort_X]] : d3.range(xLayers.length);
                if (rev) { xSorter = xSorter.reverse() }
            } else {
                if (sort_Y.endsWith("_des")) {
                    rev = true;
                    sort_Y = sort_Y.replace('_des', '')
                }
                ySorter = sort_Y !== "normal" ? [...this.rawData.sorts.Y[sort_Y]] : d3.range(yLayers.length);
                if (rev) { ySorter = ySorter.reverse() }
            }
        }, this);

        let sizeEqual = true;
        if (this.sizeLimit && sizeLimit) {
            sizeEqual = this.sizeLimit.join('_') === sizeLimit.join('_');
        }

        let recencyEqual = true;
        if (this.recencyLimit && recencyLimit) {
            recencyEqual = this.recencyLimit.join('_') === recencyLimit.join('_');
        }

        let reprocess = (!(this.z === z && this.filtNum === filtNum && this.processedData && this.processedData.length > 0 && sizeEqual && recencyEqual));
        let cntr = 0;
        this.dataNormX = {};
        if (reprocess) {
            this.resetSelect(); // Selection are not correct anymore on
            this.processedData = [];
        }
        // xSorter (and ySorter) contain original position of sorted element

        xSorter.forEach(function(ox, k) {
            ySorter.forEach(function(oy, l) {
                let el = this.rawData.data[filtNum][
                    [ox, oy, z, 0].join('_')
                ];
                if (el) {
                    if (l in this.dataNormX) {
                        this.dataNormX[l].push(el.data.size)
                    } else {
                        this.dataNormX[l] = [el.data.size]
                    }

                    // Check if within limits - need to do it here before in-place sorting occurs
                    if (sizeLimit) {
                        if (!(sizeLimit[0] <= el.data.size && el.data.size <= sizeLimit[1])) {
                            return // Goes to next iteration (does not stop loop!)
                        }
                    }

                    if (recencyLimit) {
                        if (!(recencyLimit[0] <= d3.max([el.data.recency, -3]) && d3.min([el.data.recency, 3]) <= recencyLimit[1])) {
                            return // Goes to next iteration (does not stop loop!)
                        }
                    }

                    if (!(reprocess)) {
                        // Change data in-place for sorting
                        this.processedData[el.pos].x = k;
                        this.processedData[el.pos].y = l;

                    } else {
                        el.x = k;
                        el.y = l;
                        el.orig_x = ox;
                        el.orig_y = oy;
                        el.pos = cntr; // Internal position for updating values
                        cntr += 1;

                        // Fingerprint shows the layers (AND combination) of which this datapoint is the result
                        el.fingerprint = [];
                        el.fingerprint.push(...xLayers[ox].map(el => el ? el._id : null));
                        el.fingerprint.push(...yLayers[oy].map(el => el ? el._id : null));
                        el.fingerprint.push(...zLayersBase[z].map(el => el ? el._id : null));
                        // Experimental: Adding x title
                        el.fingerprint.push(...xLayers[ox].map(el => el ? el.name : "Unknown"));
                        // TODO: (maybe) Add also filterlayer here in fingerprint?

                        let xid = xLayers[ox].map(l => l ? l._id : "All");
                        let yid = yLayers[oy].map(l => l ? l._id : "All");
                        el.id = [xid, yid];

                        this.processedData.push(el)
                    }
                }
            }, this);
        }, this);

        if (sizeLimit || recencyLimit) {
            // It's possible that rows or columns are removed due to filtering via eg. size or recency.
            // Adapt x and y position accordingly
            let xSortSet = new Set(this.processedData.map(d => d.x));
            let ySortSet = new Set(this.processedData.map(d => d.y));
            let newX = {};
            let newY = {};
            [...xSortSet].sort((a, b) => a - b).forEach((val, cnt) => { newX[val] = cnt });
            [...ySortSet].sort((a, b) => a - b).forEach((val, cnt) => { newY[val] = cnt });
            this.processedData.forEach(d => {
                d.x = newX[d.x];
                d.y = newY[d.y]
            });
            xSorter = xSorter.filter((d, c) => xSortSet.has(c));
            ySorter = ySorter.filter((d, c) => ySortSet.has(c));
        }

        // xLayers, yLayers preprocessing and reordering
        if (!(xLayers[0])) { xLayers[0] = { _id: "x_All", "name": "All" } }
        if (!(yLayers[0])) { yLayers[0] = { _id: "y_All", "name": "All" } }
        for (let key in this.dataNormX) {
            this.dataNormX[key] = d3.max(this.dataNormX[key])
        }

        this.xLayers = xSorter.map(x => xLayers[x]);
        this.yLayers = ySorter.map(x => yLayers[x]);
        this.zLayersBase = zLayersBase;
        this.subsetLayers = subsetLayers;
        this.xSorter = xSorter;
        this.ySorter = ySorter;
        this.z = z;
        this.filtNum = filtNum;
        this.sort_X = sort_X;
        this.sort_Y = sort_Y;
        this.sizeLimit = sizeLimit;
        this.recencyLimit = recencyLimit;
    };

    getSizeRange() {
        return this.sizeRange;
    }

    getRecencyRange() {
        return this.recencyRange;
    }

    constructor(request) {
        this.request = request; // Request headers
        this.rawData = undefined; // Response
        this.xLayers = undefined; // Layers for X
        this.yLayers = undefined; // Layers for Y
        this.zLayersBase = undefined; // Layers for Z
        this.subsetLayers = undefined; // Layers for subset filters
        this.xSorter = undefined; // Contains original position of layer according to corresponding sort
        this.ySorter = undefined; // Contains original position of layer according to corresponding sort
        this.processedData = undefined; // Processed data for coordinates
        this.dataNormX = undefined; // Normalization data for X
        this.z = 0; // Which layer for Z will be shown
        this.filtNum = 0; // Which filterdata is used
        this.sort_X = undefined; // Sorting on this: eg. normal, size, recency, ...
        this.sort_Y = undefined; // Sorting on this: eg. normal, size, recency, ...
        this.selected = new Set(); // Contains the selected datapoints - will be used if visualization object is in select modus
        this.sizeRange = undefined;
        this.sizeLimit = undefined;
        this.recencyRange = undefined;
        this.recencyLimit = undefined;
    }

    destroy() {
        this.svg.remove();
        console.log("source destroyed");
    }
}

export { CrainD3Vis, CrainData }
